import { useRouter } from 'next/router'
import { HiOutlineStar } from 'react-icons/hi'
import { cityChoices } from 'src/common/Constants'
import { ContactApi } from 'src/common/types'
import { segment } from 'src/lib/Segments'

import ShortRating from '@components/star/ShortRating'
import { titleCase } from '@openigloo/common'

type Props = {
  data: ContactApi
  index: number
  customStyle?: string
  segmentBase?: string
}

function ContactCardTopRated({ data, index, customStyle, segmentBase = 'other' }: Props) {
  const router = useRouter()

  return (
    <div
      className={`flex cursor-pointer items-start rounded-xl border border-light-40 bg-white ${customStyle}`}
      key={index}
      onClick={() => {
        segment?.[segmentBase + '_contactcard']?.(data?.name, data?.slug)
        router.push(
          `/contact/${cityChoices.find((x) => x.label == data?.city)?.slug ?? 'nyc'}/${data?.id}/${
            data?.slug
          }`
        )
      }}
    >
      <div className="rounded-xl bg-white p-4">
        <div className="text-sm font-semibold text-dark-900">{titleCase(data.name)}</div>
        <div className="pt-2 text-sm text-mid-400">
          {data?.roles.map((x) => {
            return (
              <>
                <span>{x}</span>
                <span className="last:hidden">, </span>
              </>
            )
          })}
        </div>
        <div className="flex items-center pt-3">
          <ShortRating
            value={data?.averageRating}
            count={data?.reviewCount}
            titleStyle="text-dark-900 text-xs font-semibold"
            countStyle="text-xs"
          />
          {data?.averageRating >= 4.3 && data?.reviewCount >= 10 && (
            <div className="ml-4 flex items-center rounded-md border border-yellow-400 py-1 px-2">
              <HiOutlineStar size={14} color="#FF991F" />
              <span className="pl-2 text-[10px] font-semibold text-dark-900">Top Rated</span>
            </div>
          )}
          {data?.latestWorstLandlordsYear && (
            <div className="pl-2 pt-0.5 text-sm text-red-500">Worst landlord</div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ContactCardTopRated
